// Sustemia · Balance Hídrico · paleta del semáforo
// Portado de la hoja "ESTADOS DEL BALANCE" del spec.
//
// "Los hex son una extensión de paleta PROPUESTA, sin aprobación del Design
// System Owner. Aislados en un solo objeto" — tal como pide la propia hoja,
// vive únicamente acá: cambiar la paleta es editar este objeto, no auditar
// cada componente que muestra el semáforo.
//
// Un estado nunca se comunica solo por color (regla de la misma hoja): en
// cada uso va siempre acompañado de ícono + texto.
export const COLOR_POR_CLAVE = {
  vacio: "#578EBF", // Mid — "todavía no cargaste nada"
  cargando: "#578EBF", // Mid — periodo.cerrado = false
  parcial: "#578EBF", // Mid — faltan flujos por cargar
  negativo: "#C0392B", // diferencia < 0
  cero: "#C0392B", // diferencia = 0 exacto
  a: "#2E7D5B", // pct ≤ 5%
  b: "#7FA83F", // pct ≤ 10% — margen de cierre confirmado por el cliente
  d: "#E07B39", // pct ≤ 25%
  e: "#C0392B", // pct > 25%
  d0: "#578EBF", // Mid — modo sin medidores: punto de partida, no veredicto
};

/** Estilo listo para un Message/Segment: borde + fondo tenue del color de la clave. */
export function estiloDeClave(clave) {
  const hex = COLOR_POR_CLAVE[clave] || COLOR_POR_CLAVE.vacio;
  return { borderLeft: `6px solid ${hex}`, backgroundColor: `${hex}1A` };
}

export default { COLOR_POR_CLAVE, estiloDeClave };
